export default __webpack_public_path__ + "static/counterfeit_banner-554db276de21ffed7ea3111ce28024aa.png";